import { SequenceEntityService } from '../../../sequence/services/sequence.entity.service';
import { ExplanationContentEntityService } from '../../../explanation/content/services/explanation-content.entity.service';
import { Injectable, inject } from '@angular/core';
import { ExplanationEntityService } from '../../../explanation/services/explanation.entity.service';
import { TestEntityService } from '../../../test/services/test.entity.service';
import { EntityService } from '../../../core/services/entity.service';

@Injectable({ providedIn: 'root' })
export class LearningSectionContainerContentService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private services: Record<string, EntityService<any>>;

  constructor() {
    const sequence = inject(SequenceEntityService);
    const explanationContent = inject(ExplanationContentEntityService);
    const explanation = inject(ExplanationEntityService);
    const test = inject(TestEntityService);

    this.services = {
      'sequences': sequence,
      'explanation-contents': explanationContent,
      'explanations': explanation,
      'tests': test,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getService(resourceType: string): EntityService<any> | undefined {
    return this.services[resourceType];
  }
}
